"use strict";

module.exports = require("./Geolocation");


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-geolocation/lib/js/index.js
// module id = 283
// module chunks = 93